/** Formata valor do datepicker ou string para dd/MM/yyyy (API pdv-api). */
export function formatarDataApi(valor: unknown, padrao = '01/01/2000'): string {
  if (valor == null || valor === '') {
    return padrao;
  }
  if (typeof valor === 'string') {
    const texto = valor.trim();
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
      return texto;
    }
  }
  const data = valor instanceof Date ? valor : new Date(valor as string);
  if (isNaN(data.getTime())) {
    return padrao;
  }
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const ano = data.getFullYear();
  return `${dia}/${mes}/${ano}`;
}

/** Converte string dd/MM/yyyy (ou Date) em Date para uso no mat-datepicker. */
export function parseDataApi(valor: unknown): Date | null {
  if (valor == null || valor === '') {
    return null;
  }
  if (valor instanceof Date) {
    return isNaN(valor.getTime()) ? null : valor;
  }
  const texto = String(valor).trim();
  const m = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) {
    const data = new Date(+m[3], +m[2] - 1, +m[1]);
    return isNaN(data.getTime()) ? null : data;
  }
  const data = new Date(texto);
  return isNaN(data.getTime()) ? null : data;
}
